import $ from 'jquery/src/jquery';
import {getUrlWithSerializedForm} from "../functions";
import SiteHeader from "../modules/site-header";

export default () => {
    const nodeSelectors = {
        container: '[js-news-filters="container"]',
        response: '[js-news-filters="response"]',
        form: '[js-news-filters="form"]',
        pageInput: '[js-news-filters="page-input"]',
        loadMoreButton: '[js-news-filters="load-more-button"]',
        loadMoreButtonHolder: '[js-news-filters="load-more-button-holder"]',
        filterInput: '[js-news-filters="filter-input"]',

        loader: '[js-news-filters="loader"]',
        isLoadMore: '[js-news-filters="is-load-more"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        filterPosts(false)

        // $(nodeSelectors.filterInput).on('change', function (e) {
        //     resetPageNumber()
        //     $(nodeSelectors.isLoadMore).val("0")
        //     filterPosts(false)
        //
        //     let val = $(this).val()
        //     $(nodeSelectors.filterSelect).val(val).trigger('change.select2');
        // })

        $(nodeSelectors.loadMoreButton).on('click', function(){
            let tmp = parseInt($(nodeSelectors.pageInput).val())
            tmp++
            $(nodeSelectors.pageInput).val(tmp)
            $(nodeSelectors.isLoadMore).val("1")
            filterPosts(true)
        });
    }

    function filterPosts(loadMore = false) {
        if( !loadMore ) {
            $(nodeSelectors.response).addClass("loading");
        }

        // Show loader
        $(nodeSelectors.loader).show()

        $.ajax({
            url: site_data.site_url + "/wp-admin/admin-ajax.php",
            data: $(nodeSelectors.form).serialize(),
            type: "GET",
            beforeSend: function (xhr) {},
            success: function (data) {
                let objData = JSON.parse(data);

                if( !objData.next_page_posts ) {
                    hideLoadMoreBtn();
                } else {
                    showLoadMoreBtn();
                }

                if( loadMore ) {
                    document.querySelector(nodeSelectors.response).innerHTML += objData.html;
                } else {
                    $(nodeSelectors.response).html(objData.html);
                }
            },
            error: function (error) {
                console.log(error)
            },
            complete: function (data) {
                // let objData = JSON.parse(data);

                // Remove loader
                $(nodeSelectors.loader).fadeOut()

                // Remove loading state
                $(nodeSelectors.response).removeClass("loading");

                if( loadMore ) { $('.newly-loaded').slideDown(250); }

                // Set new url
                history.pushState(null, null, getUrlWithSerializedForm($(nodeSelectors.form)));

                // Return to top of posts
                // $("html, body").stop().animate({scrollTop: $(nodeSelectors.container).position().top - 50 }, 300, 'swing', function () {
                //     setTimeout(function () {
                //         SiteHeader().hide()
                //     }, 20)
                // });
            },
        });
    }

    function hideLoadMoreBtn() {
        $(nodeSelectors.loadMoreButtonHolder).slideUp()
    }

    function showLoadMoreBtn() {
        $(nodeSelectors.loadMoreButtonHolder).slideDown()
    }

    function resetPageNumber() {
        $(nodeSelectors.pageInput).val('1');
    }

    return Object.freeze({
        init,
    })
}